import React from "react"

type Props = {
  className?: string
}

const DesignIcon = ({ className }: Props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9.99924 5.3125C9.87257 5.3125 9.77007 5.415 9.77174 5.54167C9.77174 5.66833 9.87424 5.77083 10.0009 5.77083C10.1276 5.77083 10.2301 5.66833 10.2301 5.54167C10.2284 5.415 10.1267 5.3125 9.99924 5.3125"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.76993 9.99899C5.76993 9.87233 5.66743 9.76983 5.5416 9.77149C5.41493 9.77149 5.31243 9.87399 5.31243 10.0007C5.31243 10.1273 5.41493 10.2298 5.5416 10.2298C5.66826 10.2298 5.76993 10.1265 5.76993 9.99899"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.3141 6.6852C13.225 6.59603 13.08 6.59603 12.9916 6.68603C12.9025 6.7752 12.9025 6.9202 12.9916 7.00936C13.0808 7.09853 13.2258 7.09853 13.315 7.00936C13.4041 6.91936 13.4041 6.7752 13.3141 6.6852"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.00822 12.9909C6.91905 12.9017 6.77405 12.9017 6.68572 12.9917C6.59655 13.0809 6.59655 13.2259 6.68572 13.315C6.77488 13.4042 6.91988 13.4042 7.00905 13.315C7.09822 13.2259 7.09822 13.0809 7.00822 12.9909"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.00922 7.00822C7.09839 6.91905 7.09839 6.77405 7.00839 6.68572C6.91922 6.59655 6.77422 6.59655 6.68506 6.68572C6.59589 6.77488 6.59589 6.91988 6.68506 7.00905C6.77422 7.09822 6.91922 7.09822 7.00922 7.00822"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.0001 17.4996C5.78761 17.4996 2.38594 14.0263 2.50344 9.78712C2.61178 5.87379 5.87428 2.61129 9.78761 2.50296C14.0268 2.38546 17.5001 5.78712 17.5001 9.99962V10.833C17.5001 11.7538 16.7543 12.4996 15.8334 12.4996H14.1143C13.0068 12.4996 12.2076 13.5596 12.5118 14.6238L12.7259 15.3746C13.0309 16.4396 12.2309 17.4996 11.1243 17.4996H10.0001Z"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default DesignIcon
